import "./Input.css";

export default function Input({
  label,
  id,
  type = "text",
  value,
  onChange,
  placeholder,
  error,
  disabled = false,
  autoComplete,
  inputMode,
  maxLength,
}) {
  return (
    <div className="form-input">
      {label && (
        <label className="form-input__label" htmlFor={id}>
          {label}
        </label>
      )}

      <input
        id={id}
        className={`form-input__field ${error ? "form-input__field--error" : ""}`}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={autoComplete}
        inputMode={inputMode}
        maxLength={maxLength}
      />

      {error && <p className="form-input__error">{error}</p>}
    </div>
  );
}
